<template>
  <boxwrap class="match--inner">
    <toolbar>
      <toolbar-items>
        <button
          class="btn--back"
          @click="goBack()"
        >
          <span>back</span>
        </button>

        <h2 class="match-heading" v-if="match.home_team_meta && match.away_team_meta">

        </h2>

        <button
          class="btn--create"
          title="add user"
          @click="add"
        >
          <i class="ico--create"></i>
        </button>

        <button
          class="btn--refresh"
          title="add user"
          @click="reset"
        >
          <i class="ico--refresh"></i>
        </button>
      </toolbar-items>

      <toolbar-items class="match-details">
        <div class="match__head">
          <div class="match__head-title">
            <span>{{ match.league }}</span>
          </div>
          <div class="match__head-action">
            <checkbox
              type="toggle"
              class="toggle--inverted"
              toggleA="show"
              toggleB="hide"
            >
              <input type="checkbox" v-model="match.active"/>
            </checkbox>

            <button
              class="btn--edit"
              title="edit"
            >
              <i class="ico--edit"></i>
            </button>

            <button
              class="btn--modify"
              title="save"
            >
              <i class="ico--save"></i>
            </button>

            <button
              class="btn--delete"
              title="save"
            >
              <i class="ico--close"></i>
            </button>
          </div>
        </div>

        <div class="match__body">
          <div class="match__row -teams">
            <div class="match__data">{{ match.home_team }} vs {{ match.away_team }}</div>
            <div class="match__data -status">
              <select-list
                :title="match.status"
                v-model="match.status"
              >
                <select-option
                  key="waiting"
                  name="waiting"
                  value="waiting"
                >
                  waiting
                </select-option>

                <select-option
                  key="ongoing"
                  name="ongoing"
                  value="ongoing"
                >
                  ongoing
                </select-option>

                <select-option
                  key="done"
                  name="done"
                  value="done"
                >
                  done
                </select-option>

                <select-option
                  key="cancelled"
                  name="cancelled"
                  value="cancelled"
                >
                  cancelled
                </select-option>

                <select-option
                  key="void"
                  name="void"
                  value="void"
                >
                  void
                </select-option>
              </select-list>
            </div>
          </div>

          <div class="match__row -dates">
            <div class="match__data">Created At: {{ match.created_at | date }}</div>
            <div class="match__data">Updated At: {{ match.updated_at | date }}</div>
          </div>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents>

      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
        v-else
      >
      <!-- :dataLoading="isDataLoading" -->
        <tbl-inner>
          <!-- v-if="!isDataLoading" -->
          <tbl-head>
            <tbl-row>
              <tbl-td name="checkbox">
                <checkbox>
                  <input
                    type="checkbox"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td name="is-saved">
              </tbl-td>

              <tbl-td name="match-type">
                match type
              </tbl-td>

              <tbl-td name="match-date">
                match date
              </tbl-td>

              <tbl-td name="val-l">
                1
              </tbl-td>

              <tbl-td name="val-x">
                x value
              </tbl-td>

              <tbl-td name="val-2">
                2
              </tbl-td>

              <tbl-td name="home-score">
                1 score
              </tbl-td>

              <tbl-td name="away-score">
                2 score
              </tbl-td>

              <tbl-td name="allow-bet">
                allow bet
              </tbl-td>

              <tbl-td name="show-hide">

              </tbl-td>

              <tbl-td name="actions">

              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="(editMatchGame, i) in editMatchGames"
              :key="editMatchGame.id"
            >
              <tbl-td name="checkbox">
                <checkbox>
                  <input
                    type="checkbox"
                    v-model="selected"
                    :value="editMatchGame.id"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td name="is-saved">
                <span v-if="editMatchGame.id">
                  saved
                </span>
              </tbl-td>

              <tbl-td name="match-type">
                <select-list
                  :title="types | filterMatchType(editMatchGame.match_type)"
                  v-if="editMatchGame.shouldEdit"
                  v-model="editMatchGame.match_type"
                >
                  <select-option
                    :key="type.id"
                    :name="type.name"
                    :value="type.id"
                    v-for="type in types"
                  >
                    {{ type.name }}
                  </select-option>
                </select-list>

                <span v-else>
                  {{ types | filterMatchType(editMatchGame.match_type) }}
                </span>
              </tbl-td>

              <tbl-td name="match-date">
                <date-time-picker
                  mode="play-date"
                  type="datetime"
                  placeholder="Play Date"
                  v-model="editMatchGame.play_date"
                  :range="false"
                  v-if="editMatchGame.shouldEdit"
                >
                </date-time-picker>

                <span v-else>
                  {{ editMatchGame.play_date | date }}
                </span>
              </tbl-td>

              <tbl-td @click.native="openBet(editMatchGame, '1')" name="val-l">
                <div
                  class="input-wrap"
                  v-if="editMatchGame.shouldEdit"
                >
                  <input
                    v-model="editMatchGame['1_val']"
                    type="text"
                  />
                </div>

                <span v-else>{{ editMatchGame['1_val'] }}</span>

                <div v-if="editMatchGame.meta">
                  <hr>
                  {{ editMatchGame.meta.bet_1 || 0 | FormatAmount }} / {{ editMatchGame.meta.win_1 || 0 | FormatAmount }}
                </div>
              </tbl-td>

              <tbl-td @click.native="openBet(editMatchGame, 'x')" name="val-x">
                <div
                  class="input-wrap"
                  v-if="editMatchGame.shouldEdit"
                >
                  <input
                    v-model="editMatchGame['x_val']"
                    type="text"
                  />
                </div>

                <span v-else>{{ editMatchGame['x_val'] }}</span>

                <div v-if="editMatchGame.meta">
                  <hr>
                  {{ editMatchGame.meta.bet_x || 0 | FormatAmount }} / {{ editMatchGame.meta.win_x || 0 | FormatAmount }}
                </div>
              </tbl-td>

              <tbl-td @click.native="openBet(editMatchGame, '2')" name="val-2">
                <div
                  class="input-wrap"
                  v-if="editMatchGame.shouldEdit"
                >
                  <input
                    v-model="editMatchGame['2_val']"
                    type="text"
                  />
                </div>

                <span v-else>{{ editMatchGame['2_val'] }}</span>

                <div v-if="editMatchGame.meta">
                  <hr>
                  {{ editMatchGame.meta.bet_2 || 0 | FormatAmount }} / {{ editMatchGame.meta.win_2 || 0 | FormatAmount }}
                </div>
              </tbl-td>

              <tbl-td name="home-score">
                <div
                  class="input-wrap"
                  v-if="editMatchGame.shouldEdit"
                >
                  <input
                    v-model="editMatchGame.home_score"
                    type="text"
                  />
                </div>

                <span v-else>
                  {{ editMatchGame.home_score }}
                </span>
              </tbl-td>

              <tbl-td name="away-score">
                <div
                  class="input-wrap"
                  v-if="editMatchGame.shouldEdit"
                >
                  <input
                    v-model="editMatchGame.away_score"
                    type="text"
                  />
                </div>

                <span v-else>
                  {{ editMatchGame.away_score }}
                </span>
              </tbl-td>

              <tbl-td name="allow-bet">
                <checkbox
                  type="toggle"
                  class="toggle--inverted"
                  toggleA="active"
                  toggleB="inactive"
                  :disabled="!editMatchGame.shouldEdit"
                  v-if="editMatchGame.shouldEdit"
                >
                  <input
                    type="checkbox"
                    v-model="editMatchGame.isBetting"
                  />
                </checkbox>

                <span v-else>
                  {{ editMatchGame.isBetting ? 'active' : 'inactive' }}
                </span>
              </tbl-td>

              <tbl-td name="show-hide">
                <checkbox
                  type="toggle"
                  class="toggle--inverted"
                  toggleA="show"
                  toggleB="hide"
                  :disabled="!editMatchGame.shouldEdit"
                  v-if="editMatchGame.shouldEdit"
                >
                  <input
                    type="checkbox"
                    v-model="editMatchGame.isShow"
                  />
                </checkbox>

                <span v-else>
                  {{ editMatchGame.isShow ? 'show' : 'hide' }}
                </span>
              </tbl-td>

              <tbl-td name="actions">
                <button
                  class="btn--matches"
                  v-if="editMatchGame.result !== 'N'"
                  title="result"
                  @click="triggerRollback(editMatchGame)"
                >
                  <!-- <i class="ico--refresh"></i> -->
                   <span>Rollback</span>
                </button>

                <button
                  class="btn--matches"
                  title="result"
                  v-if="editMatchGame.result === 'N'"
                  @click="triggerResult(editMatchGame)"
                >
                  <!-- <i class="ico--edit"></i> -->
                  <span>Result</span>
                </button>

                <button
                  class="btn--modify"
                  v-if="editMatchGame.shouldEdit"
                  @click="save(editMatchGame.id)"
                >
                  <i class="ico--save"></i>
                </button>

                <button
                  class="btn--edit"
                  v-else
                  @click="editMatchGame.shouldEdit = !editMatchGame.shouldEdit, setSelected(editMatchGame)"
                >
                  <i class="ico--edit"></i>
                </button>

                <button
                  class="btn--delete"
                  title="delete"
                  v-if="editMatchGame.id"
                  @click="deleteData(editMatchGame.id)"
                >
                  <i class="ico--delete"></i>
                </button>

                <button
                  class="btn--delete"
                  title="remove"
                  v-if="!editMatchGame.id"
                  @click="remove(i)"
                >
                  <i class="ico--close"></i>
                </button>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <button
            class="btn--modify -withlabel"
            @click="save()"
          >
            <i class="ico--save"></i>
            <span>save game</span>
          </button>

          <button
            class="btn--delete -withlabel"
            @click="del()"
            v-if="selected.length"
          >
            <i class="ico--delete"></i>
            <span>delete</span>
          </button>

        </tbl-footer>
      </tbl>
    </boxwrap-contents>
  </boxwrap>
</template>

<script>
//= components
import { mapGetters, mapActions } from 'vuex'
import DateTimePicker from '@/components/base/DateTimePicker'
import Checkbox from '@/components/base/Checkbox'
import TextArea from '@/components/base/TextArea'
import CheckDataList from '@/components/base/CheckDataList'
import FormatAmount from '@/assets/js/filters/FormatAmount'

import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'

//= mixin
import { swal } from '@/assets/js/mixins/base/Swal'

export default {
  name: 'match',

  components: {
    DateTimePicker,
    Checkbox,
    TextArea,
    CheckDataList
  },

  mixins: [
    swal
  ],

  data () {
    return {
      editMatchGames: [],
      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      selected: []
    }
  },

  async created () {
    let q = this.$route.params.id
    await this.find(q); await this.get({ filter_by: 'match_id', q })
    await this.getTypes()
    this.editMatchGames = this.matchGames.length
      ? this.matchGames.slice(0)
      : this.createBase()

    // == flags set
    this.isDataLoading = false
    this.showDataLoading = false
    if (!this.editMatchGames.length) {
      this.isEmpty = false
    }
  },

  filters: {
    filterMatchType (types, matchTypeId) {
      let typeName

      types.forEach((data) => {
        if (data.id === matchTypeId) {
          typeName = data.name
        }
      })

      return typeName
    },
    FormatAmount
  },

  computed: {
    ...mapGetters('match', ['match', 'types']),
    ...mapGetters('match-game', ['matchGames'])
  },

  methods: {
    ...mapActions('match', ['find', 'getTypes']),
    ...mapActions('match-game',
      ['get', 'create', 'delete', 'update', 'result', 'rollback']
    ),

    goBack () {
      window.history.go(-1)
    },

    openBet (matchGame, part) {
      if (matchGame.shouldEdit) return
      let id = matchGame.id
      let url = `${process.env.VUE_APP_URL}/bet-history/matches/`
       + `?filter_by=match_game_id&q=${id}&area=${part}`

      window.open(
       url, '', `width=${1400},height=${window.innerHeight}`
      )
    },

    make (type) {
      return {
        play_date: new Date(this.match.play_date),
        match_id: this.$route.params.id,
        '1_val': 0,
        'x_val': 0,
        '2_val': 0,
        match_type: type || null,
        shouldEdit: true
      }
    },

    createBase () {
      let matches = []
      for (let i = 0; i < this.types.length; i++) {
        matches.push(this.make(this.types[i].id))
      }

      return matches
    },

    add () {
      this.editMatchGames.push(this.make())
    },

    reset (id) {
      if (id) {
        let idx = this.editMatchGames.findIndex((e) => {  return e.id === id })

        this.editMatchGames[idx].shouldEdit = false
        this.editMatchGames[idx] = this.matchGames.find((e) => {
          return e.id === id
        })
        let idxx = this.selected.indexOf(id)
        this.selected.splice(idxx, 1)
        return
      }
      this.editMatchGames = this.matchGames.length
        ? this.matchGames.slice(0) : this.createBase()

      this.selected = []
    },

    remove (index) {
      this.editMatchGames.splice(index, 1)
    },

    async singleUpdate () {
      this.$alert('prompt', 'Are you sure you want to continue?', {},
        async () => {
        }, 'Modify')
    },

    async save (id) {
      this.$alert('prompt', 'Are you sure you want to continue?', {}, {
        success: async () => {

          let matchGames = this.editMatchGames
            .filter((row) => {
              return row.shouldEdit
            })

          if (id) {
            matchGames = this.editMatchGames.filter((row) => {
              return row.id === id
            })
          }

          let edit = matchGames.filter((row) => { return row.id })
          let create = matchGames.filter((row) => { return !row.id })

          if (create.length) {
            await this.create(create)
          }

          for (let i = 0; i < edit.length; i++) {
            await this.update(edit[i])
          }

          await this.get({ filter_by: 'match_id', q: this.$route.params.id })
          this.reset(id)
        }
      }, 'Modify Match')
    },

    async del () {
      this.$alert('prompt', 'Are you sure you want to delete this?', {},
        {
          success: async () => {
            for (var x = 0; x < this.selected.length; x++) {
              await this.delete(this.selected[x])
            }
            await this.get({ filter_by: 'match_id', q: this.$route.params.id })
            this.reset()
          }
        },'Delete Match')
    },

    async triggerRollback (game) {
      this.$alert(
        'prompt', 'Are you sure you want to rollback?', {},
        {
          success: async () => {
            await this.rollback(game)
            await this.get({
              filter_by: 'match_id', q: this.$route.params.id
            })

            this.reset()
          }
        }, 'Rollback Match'
      )
    },

    async triggerResult (game) {
      this.$alert('prompt', 'Are you sure you want to payout?', {},
        {
          success: async () => {
            await this.result(game)
            await this.get({
              filter_by: 'match_id', q: this.$route.params.id
            })
            this.reset()
          }
        }, 'Rollback Match'
      )
    },

    async deleteData (id) {
      this.$alert('prompt', 'Are you sure you want to delete this?', {},
        {
          success: async () => {
            await this.delete(id)
            await this.get({ filter_by: 'match_id', q: this.$route.params.id })
            this.reset()
          }
        },
        'Delete Match')
    },

    setSelected (data) {
      let idx = this.selected.indexOf(data.id)
      if (idx > -1 && !data.shouldEdit) {
        this.selected.splice(idx, 1)
        return
      }

      if (data.shouldEdit) {
        this.selected.push(data.id)
      }


      console.log(this.selected)
    }
  }
}
</script>
